const ServiceData = {
    STitle: "You SaasLand wherever your business agency",
    Service: [
        {
            id: 1,
            shape: "icon_shape1.png",
            icon: "ti-panel",
            text: "Export Presets",
            description:
                "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
            btn: "Read More",
            bicon: "ti-arrow-right",
        },
        {
            id: 2,
            shape: "icon_shape2.png",
            icon: "ti-layout-grid2",
            text: "Grid and Guides",
            description:
                "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
            btn: "Read More",
            bicon: "ti-arrow-right",
        },
        {
            id: 3,
            shape: "icon_shape3.png",
            icon: "ti-gallery",
            text: "Prototyping",
            description:
                "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
            btn: "Read More",
            bicon: "ti-arrow-right",
        },
        {
            id: 4,
            shape: "icon_shape4.png",
            icon: "ti-fullscreen",
            text: "Pixel Precision",
            description:
                "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
            btn: "Read More",
            bicon: "ti-arrow-right",
        },
    ],
    agtext1: "Why I say old chap that is spiffing bodge, blag pardon.",
    agtext2: "Why I say old chap that is spiffing bodge, blag pardon.",
    agtext3: "Starkers dropped a clanger lurgy is cack excuse my French what.",
    pServiceTitle: "Our Services",
    pServiceDetails:
        "Why I say old chap that is, spiffing jolly good a load of old tosh spend a penny tosser arse over.!",
    PaymentService: [
        {
            id: 1,
            image: "icon4.png",
            title: "Safer",
            description: "Well at public scho cheeky bugger grub burke.",
        },
        {
            id: 2,
            image: "icon7.png",
            title: "Flexible",
            description: "Well at public scho cheeky bugger grub burke.",
        },
        {
            id: 3,
            image: "icon5.png",
            title: "Convinient",
            description: "Well at public scho cheeky bugger grub burke.",
        },
        {
            id: 4,
            image: "icon8.png",
            title: "Protected",
            description: "Well at public scho cheeky bugger grub burke.",
        },
        {
            id: 5,
            image: "icon6.png",
            title: "World wide",
            description: "Well at public scho cheeky bugger grub burke.",
        },
    ],
    HRService: [
        {
            id: "1",
            slug: "cash-for-used-cars",
            HRtitles: "Cash-for-Used-Cars",
            HRdescription:
                "A point comes when we all get tired by driving the same car for years. If you are looking to sell your used car for cash, call us. We will help you in buying your desired car by paying top money for cars without worrying about the condition of your vehicle.",
            Hicon: "cash-for-used-car",
            rclass: "pr_70",
            iclass: "icon_one",
        },
        {
            id: "2",
            slug: "cash-for-junk-cars",
            HRtitles: "Cash-for-Junk-Cars",
            HRdescription:
                "We are leading junk car buyer near you. Let us know the basic details about your vehicle (age, make, model, mileage, and condition), and we will help you with our junk car removal services in Brisbane. Besides paying you cash for junk cars we will wreck your car",
            Hicon: "cash-for-junk-car",
            rclass: "pl_50 pr_20",
            iclass: "icon_two",
        },
        {
            id: "3",
            slug: "all-brand-car-wreckers",
            HRtitles: "All-Brand-Car-Wreckers",
            HRdescription:
                "We adore every vehicle of any brand, make, model, and year. We are car wreckers that wreck cars of all Japanese, American, and European brands such as Chrysler, Ford, Mazda, Dodge, Nissan, BMW, Honda, Mitsubishi, Subaru, Toyota, Volkswagen, and many more.",
            Hicon: "brand-car-wreck",
            rclass: "pl_70",
            iclass: "icon_three",
        },
        {
            id: "4",
            slug: "cash-for-damamged-cars",
            HRtitles: "Cash-for-Damaged-Cars",
            HRdescription:
                "There is no point of keeping a damaged car with you and paying its repair bills monthly when you can make some top cash for damaged cars. At A1 Auto Recycling, we offer instant and maximum cash for damaged car removals. It does not matter whether your vehicle is in one piece or crumbled in an accident, we are the one-stop solution for your damaged car removal.",
            Hicon: "cash-for-damaged-car",
            rclass: "pr_70",
            iclass: "icon_four",
        },
        {
            id: "5",
            slug: "free-scrap-removal",
            HRtitles: "Free-Scrap-Car-Removal",
            HRdescription:
                "Our free scrap car removal service is the best thing available to you when you choose us to get relived on your scrap car for cash. We understand how to scrap cars just sit in your backyard and get rusted. They are not only harmful to the environment but for you as well. Driving a scrap car is always risky, get rid of it today before it may harm you or your loved ones. Call us today.",
            Hicon: "free-scrap-removal",
            rclass: "pl_50 pr_20",
            iclass: "icon_five",
        },
        {
            id: "6",
            slug: "unwanted-car-buyer",
            HRtitles: "Unwanted-Car-Buyer",
            HRdescription:
                "If you are searching about how to get rid of your unwanted car, your search ends here! We are unwanted car buyer that will make you able to make more cash from your unwanted car. Our cash for cars removal services start from giving a free quote and ends at free car removal.We provide you the best services at an affordablle price and we fulfill your requirements within a specified time period.",
            Hicon: "unwanted-car-buyers",
            rclass: "pl_70",
            iclass: "icon_six",
        },
    ],
    rpost: [
        {
            id: "01",
            image: "blog-grid/post_1.jpg",
            ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
            admin: "Admin",
            date: "March 1, 2019",
        },
        {
            id: "02",
            image: "blog-grid/post_2.jpg",
            ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
            admin: "Admin",
            date: "March 10, 2019",
        },
        {
            id: "03",
            image: "blog-grid/post_3.jpg",
            ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
            admin: "Admin",
            date: "jan 10, 2019",
        },
        {
            id: "04",
            image: "blog-grid/post_4.jpg",
            ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
            admin: "Admin",
            date: "March 1, 2019",
        },
    ],
    Blist: [
        {
            id: "01",
            image: "blog-grid/blog_list1.jpg",
            btitle: "Why I say old chap that is, spiffing jolly good.",
            bdescription:
                "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
            pdate: "10",
            Month: "March",
        },
        {
            id: "02",
            image: "blog-grid/blog_list2.jpg",
            btitle: "Why I say old chap that is, spiffing jolly good.",
            bdescription:
                "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
            pdate: "10",
            Month: "June",
        },
        {
            id: "03",
            image: "blog-grid/blog_list3.jpg",
            btitle: "Why I say old chap that is, spiffing jolly good.",
            bdescription:
                "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
            pdate: "10",
            Month: "March",
        },
        {
            id: "04",
            image: "blog-grid/blog_list4.jpg",
            btitle: "Bloke cracking goal the full monty get stuffed mate posh.",
            bdescription:
                "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
            pdate: "01",
            Month: "July",
        },
    ],
    work: [
        {
            id: "01",
            icon: "ti-settings one",
            title: "Premium plugins",
            p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
        },
        {
            id: "02",
            icon: "ti-heart-broken two",
            title: "Premium plugins",
            p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
        },
        {
            id: "03",
            icon: "ti-target  three",
            title: "Live page builder",
            p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
        },
    ],
};
export default ServiceData;
